import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraBadge } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
/** Read-only claims. A claim without proof is flagged, never silently shown as fine. */ export function WinThemeClaims({ claims }) {
    if (!claims.length) return /*#__PURE__*/ _jsx("p", {
        className: "text-sm text-muted-foreground",
        children: "No claims recorded."
    });
    return /*#__PURE__*/ _jsx("ul", {
        className: "space-y-2",
        children: claims.map((claim, index)=>/*#__PURE__*/ _jsxs("li", {
                "data-testid": Testids.winThemes.claim,
                className: "space-y-1 rounded-md border p-2",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "whitespace-pre-wrap",
                        children: claim.claimText
                    }),
                    claim.supported ? /*#__PURE__*/ _jsx("ul", {
                        className: "text-sm text-muted-foreground",
                        children: claim.proofLinks.map((proof)=>proof.accessible ? /*#__PURE__*/ _jsxs("li", {
                                "data-testid": Testids.winThemes.proofLink,
                                children: [
                                    "Proof (",
                                    proof.kind,
                                    "): ",
                                    proof.label || proof.id
                                ]
                            }, `${proof.kind}:${proof.id}`) : /*#__PURE__*/ _jsx("li", {
                                "data-testid": Testids.winThemes.restrictedProof,
                                children: "Restricted source"
                            }, `${proof.kind}:${proof.id}`))
                    }) : /*#__PURE__*/ _jsxs("p", {
                        className: "text-sm",
                        children: [
                            /*#__PURE__*/ _jsx(SpecraBadge, {
                                "data-testid": Testids.winThemes.unsupportedBadge,
                                children: "Unsupported"
                            }),
                            ' ',
                            "No proof attached"
                        ]
                    })
                ]
            }, index))
    });
}
